import { render, staticRenderFns } from "./itemSancion.vue?vue&type=template&id=0c30d88b&"
import script from "./itemSancion.vue?vue&type=script&lang=js&"
export * from "./itemSancion.vue?vue&type=script&lang=js&"
import style0 from "./itemSancion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports